import React, { useState, useEffect } from 'react';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOnlineNotification, setShowOnlineNotification] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOnlineNotification(true);
      
      // Hide the "Back online" banner after 3 seconds
      setTimeout(() => {
        setShowOnlineNotification(false);
      }, 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOnlineNotification(false); // hide the online banner if it was showing
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // If online and we shouldn't show the notification, render nothing
  if (isOnline && !showOnlineNotification) {
    return null;
  }

  const styles = {
    container: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      padding: '10px',
      textAlign: 'center',
      color: '#fff',
      fontWeight: 'bold',
      fontSize: '14px',
      transition: 'all 0.3s ease-in-out',
    },
    offline: {
      backgroundColor: '#f44336', // Red
    },
    online: {
      backgroundColor: '#4caf50', // Green
    }
  };

  return (
    <div 
      style={{
        ...styles.container,
        ...(isOnline ? styles.online : styles.offline)
      }}
    >
      {isOnline ? 'De nouveau connecté à Internet' : 'Vous êtes hors ligne. Vérifiez votre connexion.'}
    </div>
  );
};

export default NetworkStatus;
